import { Component, EventEmitter, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GenerateTicketModalComponent } from '../generate-ticket-modal/generate-ticket-modal.component';
import { Location } from "@angular/common";
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';


@Component({
  selector: 'app-e-ticket-list',
  standalone: false,
  templateUrl: './e-ticket-list.component.html',
  styleUrl: './e-ticket-list.component.scss'
})
export class ETicketListComponent {
  action_idx: any = null;

  ticketList: any[] = [];
  form!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedTicketNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 20;
  selectedLimit: number = 10;


  errorFetchingData: boolean = false;


  @Output() onConfirmClicked = new EventEmitter();
  vehicleTypes: any[] = [];
  batchId: number;

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  clearSearchFilters() {
    this.form.reset()
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      soldStatus: [''],
      assignStatus: [''],
      ticketNumber: [''],
      offset: [''],
    });

    this.batchId = this.route.snapshot.queryParams["id"];

    if(!this.batchId){
      this.location.back()
    }


    this.search();
  }


  openRevokeConfirmModal(id: number, ticketNumber: string) {

    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Revoke " + ticketNumber + " ?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.revoke(id)

        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

}

revoke(id: number): void {

this.isLoading = true
this.apiService
  .get(`/ticket/revoke-super-agent-ticket?ticketId=${id}`)
  .pipe(
    finalize(() => {
      this.isLoading = false;
    })
  )
  .subscribe(
    (response: any) => {

      this.openSuccessModal('Ticket revoked successfuly');
    },
    (error) => {
      this.openErrorModal(error?.message)
    }
  );

}


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();

  }

  search() {
    this.ticketList = [];
    this.searchedTicketNotFound = false;
    this.errorFetchingData = false
    this.isSearching = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append('batchId', this.batchId);
    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append("soldStatus", this.form.get('soldStatus')?.value || '');
    formData.append("assignStatus", this.form.get('assignStatus')?.value || '');
    formData.append("ticketNumber", this.form.get('ticketNumber')?.value || '');

    this.apiService
      .post('/ticket/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedTicketNotFound = true;
          }



          this.ticketList = response.data;

        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true
        }
      );
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(GenerateTicketModalComponent, {
      width: '450px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,

      data,
    });

    return dialogRef;
  }



  back(){
    window.history.back()
  }
}
